import React, { useState } from 'react';
import { TextBoxComponent, MaskedTextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { AutoCompleteComponent, ComboBoxComponent} from '@syncfusion/ej2-react-dropdowns';
import './OneChange.css'

function BeneficiaryBankChange({ projectData, beneficiaryData, uniqueProjects, requestor, setNewName, setBenNewName, setProjectID, setFutureStatus, setCurrentStatus, setNotes}) {
  const [selectedID, setSelectedID] = useState("");
  const [selectedProjectNum, setSelectedProjectNum] = useState("");
  const [selectedBeneficiaries, setSelectedBeneficiaries] = useState("");
  const [selectedBenName, setSelectedBenName] = useState("");
  const [selectedBenNum, setSelectedBenNum] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  
  const handleNameChange = (e) => {
    setNewName(e.value);
    const selectedProject = e.value
    const filteredData = projectData.filter(
      (item) => item.ProjectName === selectedProject
    );
    if (filteredData.length > 0) {
      setSelectedID(filteredData[0]?.id);
      setSelectedProjectNum(filteredData[0]?.ProjectNum);
      const projectNum = filteredData[0]?.ProjectNum
      const filteredBeneficiaryData = beneficiaryData.filter(
        (item) => item.ProjNum === projectNum
      );
      const uniqueBeneficiaries = [
        ...new Set(filteredBeneficiaryData?.map((item) => item.id)),
      ];
      setSelectedBeneficiaries(uniqueBeneficiaries)
    }
    setProjectID('');
    setSelectedBenNum('');
    setSelectedBenName('')
    setBenNewName('')
    setSelectedStatus('')
  };

  const handleBenNameChange = (e) => {
    const selectedBen = e.value
    const filteredData = beneficiaryData.filter(
      (item) => item.id === selectedBen
    );
    if (filteredData.length > 0) {
      setProjectID(filteredData[0]?.id);
      setSelectedBenNum(filteredData[0]?.ID_Num);
      setSelectedStatus(filteredData[0]?.BenStatus);
      setCurrentStatus(filteredData[0]?.BenStatus);
      const firstName = filteredData[0]?.FirstNames
      const lastName = filteredData[0]?.LastName
      setSelectedBenName(firstName +' '+ lastName)
      setBenNewName(firstName +' '+ lastName)
    }
  };

  const handleNotesChange = (e) => {
    setNotes(e.value);
  };
  const handleNewStatusChange = (e) => {
    if (e !== ""){setFutureStatus(e.value)};
  };
  
  return (
    <table className='main-name-dialog'>
      <tbody className='name-field-dialog'>
        <tr className='name-change-row1'>
          <td className='name_project-id'>
            <TextBoxComponent id='id' name='id' value={selectedID} placeholder=" Proj ID" floatLabelType="Always" disabled={true}/>
          </td>
          <td className='name_project-name'>
            <AutoCompleteComponent id='name' name='name' onChange={handleNameChange} dataSource={uniqueProjects} placeholder="Project Name" floatLabelType="Always"/>
          </td>
          <td className='name_project-num'>
            <TextBoxComponent id='num' name='num' value={selectedProjectNum} placeholder="Project Number" floatLabelType="Always" disabled={true}/>
          </td>
        </tr>
        <tr className='name-change-row1'>
          <td className='name_project-id'>
            <ComboBoxComponent id='id' name='id' onChange={handleBenNameChange} dataSource={selectedBeneficiaries} placeholder="Ben. ID" floatLabelType="Always" />
          </td>
          <td className='name_project-name'>
            <TextBoxComponent id='name' name='name' value={selectedBenName} placeholder="Beneficiary Name" floatLabelType="Always" disabled={true}/>
          </td>
          <td className='name_project-num'>
            <MaskedTextBoxComponent id='num' name='num' value={selectedBenNum} placeholder="Beneficiary ID" mask={'000000 0000 000'} floatLabelType="Always" disabled={true}/>
          </td>
        </tr>
        <tr className='name-change-row2'>
          <td className='name_current-status'>
            <TextBoxComponent  id='current-status' name='current-status' value={selectedStatus} placeholder="Current Status" floatLabelType="Always" disabled={true}/>
          </td>
          <td className='name_new-status'>
          <ComboBoxComponent
              id='comboelement'
              name='comboelement'
              placeholder="New Status"
              floatLabelType="Always"
              dataSource={['Active', 'Resigned', 'Deceased']}
              change={handleNewStatusChange}
            />
          </td>
          <td className='name_requestor'>
            <TextBoxComponent  id='requestor' name='requestor' value={requestor} placeholder="Requestor" floatLabelType="Always" disabled={true}/>
          </td>
        </tr>
        <tr className='name-change-row3'>
          <td className='name_notes'>
            <TextBoxComponent  id='notes' name='notes' onChange={handleNotesChange} multiline={true} placeholder=" Notes" floatLabelType="Always" />
          </td>
        </tr>
      </tbody>
    </table>
    
  )
}

export default BeneficiaryBankChange